var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("description-container", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_c("description-heading", [_vm._v(_vm._s(_vm.title))])]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.items.length > 0
              ? _c(
                  "div",
                  { staticClass: "text-sm" },
                  [
                    _vm.experience
                      ? _vm._l(_vm.sortedByDates, function (item, i) {
                          return _c(
                            "div",
                            {
                              key: item.id,
                              class: `px-4 py-4 ${
                                i < _vm.items.length - 1 ? "border-b" : ""
                              } border-gray-200`,
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex justify-between" },
                                [
                                  _c("div", { staticClass: "flex flex-col" }, [
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "text-lg leading-6 font-medium text-gray-900",
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.jobTitle) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "text-sm leading-6 font-medium text-gray-600",
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.companyName) + " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "text-xs leading-6 text-gray-800",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bg-purple-100 text-purple-900 text-xs rounded-full px-2 py-0.5",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$moment(item.startDate)
                                                  .format("MMM YYYY")
                                              ) +
                                              " – " +
                                              _vm._s(
                                                item.ongoing
                                                  ? "Present"
                                                  : _vm
                                                      .$moment(item.endDate)
                                                      .format("D MMM, YYYY")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "py-2" }, [
                                _vm._v(_vm._s(item.summary)),
                              ]),
                              _c(
                                "div",
                                { staticClass: "p-2 pb-4 space-x-2 space-y-2" },
                                _vm._l(item.skills, function (skill, i) {
                                  return _c(
                                    "span",
                                    {
                                      key: i,
                                      staticClass:
                                        "px-2 py-1 inline-flex items-center rounded-full text-xs font-medium leading-4 border border-grey-800 text-gray-800 transition duration-300",
                                    },
                                    [_vm._v(_vm._s(skill))]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        })
                      : _vm.chips
                      ? [
                          _c(
                            "div",
                            { staticClass: "p-2 pb-4 space-x-2 space-y-2" },
                            _vm._l(_vm.items, function (item) {
                              return _c(
                                "span",
                                {
                                  key: item.id,
                                  staticClass:
                                    "px-2 py-1 inline-flex items-center rounded-full text-xs font-medium leading-4 border border-grey-800 text-gray-800 transition duration-300",
                                },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            0
                          ),
                        ]
                      : _vm._l(_vm.sortedByDates, function (item) {
                          return _c("div", { key: item.id }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "px-4 py-3 border-b border-gray-100 flex items-center justify-between",
                              },
                              [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "leading-6 font-medium text-base",
                                  },
                                  [_vm._v(" " + _vm._s(item.institution) + " ")]
                                ),
                                _c(
                                  "h4",
                                  { staticClass: "leading-6 font-medium mr-2" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "bg-purple-100 text-purple-900 text-xs rounded-full px-2 py-0.5",
                                      },
                                      [_vm._v(_vm._s(item.year))]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        }),
                  ],
                  2
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "bg-gray-100 text-gray-500 opacity-50 text-sm px-4 pt-3 pb-4",
                  },
                  [_c("div", [_vm._v("n/a")])]
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }